// Campos monetários guardam apenas dígitos (centavos); a máscara exibe em reais.
export const onlyDigits = (v: string) => v.replace(/\D/g, "").slice(0, 11);

export const formatBRL = (digits: string) =>
  (Number(digits || "0") / 100).toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const centsToBRL = (cents: number) =>
  ((cents || 0) / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
